import React from "react";
import { render } from "react-dom";

import { MDXProvider } from "@mdx-js/react";

import {
  Deck,
  FlexBox,
  Slide,
  Box,
  Progress,
  FullScreen,
  Notes,
  mdxComponentMap,
} from "spectacle";
import { Theme } from "styled-system";

import OuestWareLogo from "../logo_ouestware_text_noir.svg";
import CHSPLogo from "./CHSP_en.png";

// SPECTACLE_CLI_MDX_START
import mdxSlides, { notes } from "./slides.mdx";
// SPECTACLE_CLI_MDX_END

// SPECTACLE_CLI_THEME_START
const theme: Theme = {
  fontSizes: {
    a: "unset",
    h4: "2rem",
  },
  colors: {
    primary: "#000",
    secondary: "#2a4657",
  },
};
// SPECTACLE_CLI_THEME_END

// SPECTACLE_CLI_TEMPLATE_START
const template = () => (
  <>
    <FlexBox
      justifyContent="space-between"
      position="absolute"
      top={"0px"}
      width={"100%"}
    >
      <a href="https://ouestware.com">
        <img style={{ paddingLeft: "1em" }} height="50px" src={OuestWareLogo} />
      </a>
      <img style={{ paddingRight: "1em" }} height="40px" src={CHSPLogo} />
    </FlexBox>
    <FlexBox
      justifyContent="space-between"
      position="absolute"
      bottom={0}
      width={1}
    >
      <Box padding="0 1em">
        <FullScreen color={theme.colors.secondary as string} size={20} />
      </Box>
      <Box padding="1em">
        <Progress color={theme.colors.secondary as string} size={10} />
      </Box>
    </FlexBox>
  </>
);
// SPECTACLE_CLI_TEMPLATE_END

export const Presentation = () => (
  <MDXProvider components={mdxComponentMap}>
    <Deck theme={theme} template={template}>
      {mdxSlides
        .map((MDXSlide, i) => [MDXSlide, notes[i]])
        .map(([MDXSlide, MDXNote], i) => {
          return (
            <Slide key={`slide-${i}`} slideNum={i} backgroundColor="#fff">
              <MDXSlide />
              <Notes>
                <MDXNote />
              </Notes>
            </Slide>
          );
        })}
    </Deck>
  </MDXProvider>
);
document.title = "WEHC - RICardo GeoPolHist - AFHE prize";
render(<Presentation />, document.getElementById("root"));
